import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

/**
 * Saved comparison groups (fox F9, decision 10) — the named peer sets a reader assembles on the
 * Compare page and reloads later. User-owned rows, so every op is authenticated and the server
 * scopes them by the JWT subject; nothing here takes a user id.
 */
export function createComparisonGroupQueries(client: StoxlyClient) {
  return createQueryKeys('comparisonGroups', {
    // ['comparisonGroups', 'all']
    all: {
      queryKey: null,
      queryFn: ({ signal }) => client.comparisonGroupsList({ signal }),
    },

    // ['comparisonGroups', 'detail', id]
    detail: (id: string) => ({
      queryKey: [id],
      queryFn: ({ signal }) => client.comparisonGroupsGet({ params: { id }, signal }),
    }),
  });
}

export function createComparisonGroupMutations(client: StoxlyClient) {
  return {
    create: {
      mutationFn: (body: Body<'comparisonGroupsCreate'>) => client.comparisonGroupsCreate(body),
    },
    update: {
      mutationFn: ({ id, body }: { id: string; body: Body<'comparisonGroupsUpdate'> }) =>
        client.comparisonGroupsUpdate(body, { params: { id } }),
    },
    delete: {
      mutationFn: (id: string) => client.comparisonGroupsDelete(undefined, { params: { id } }),
    },
  };
}
